import { transactionLineItems } from '../../util/api';

function getMergedLineItemsForSingleWinery(deliveryMethod, wines, winery, setlineItemsToShow) {
  var lineItemsArrayTemp = [];
  wines.forEach(async (wine, index) => {
    const quantity = wine.quantity;
    await new Promise(r => setTimeout(r, 2000));

    transactionLineItems({
      orderData: {
        quantity: quantity,
        deliveryMethod: deliveryMethod || 'shipping',
        first_bottle: index == 0,
      },
      listingId: wine.id,
      isOwnListing: wine.isOwnListing,
    })
      .then(async response => {
        const responseData = response.data;
        console.log('response here->', responseData);

        lineItemsArrayTemp.push(...responseData);

        const MyNewArray = [];
        lineItemsArrayTemp.forEach(lineItem => {
          if (MyNewArray.filter(item => item.code === lineItem.code).length == 0) {
            MyNewArray.push(lineItem);
          } else {
            const MyNewIndex = MyNewArray.findIndex(item => item.code == lineItem.code);

            MyNewArray[MyNewIndex].unitPrice.amount =
              MyNewArray[MyNewIndex].unitPrice.amount + lineItem.unitPrice.amount;
            MyNewArray[MyNewIndex].lineTotal.amount =
              MyNewArray[MyNewIndex].lineTotal.amount + lineItem.lineTotal.amount;
          }
        });
        const obj = {
          key: winery,
          value: MyNewArray,
        };
        setlineItemsToShow(lineItemsToShow => [...lineItemsToShow, obj]);
      })
      .catch(e => {
        console.error('Error', e);
      });
  });
}
export default function fetchData(cartWines, deliveryMethodValues, setlineItemsToShow) {
  Object.keys(cartWines).forEach(async key => {
    const wines = cartWines[key];

    const deliveryMethod =
      deliveryMethodValues.find(deliveyrMethodValue => deliveyrMethodValue.winery == key) &&
      deliveryMethodValues.find(deliveyrMethodValue => deliveyrMethodValue.winery === key).value;

    getMergedLineItemsForSingleWinery(deliveryMethod, wines, key, setlineItemsToShow);
  });
}
